import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box, Button,
  Card, CardContent, createStyles,
  makeStyles,
  Typography,
} from '@material-ui/core';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import type { IClarifyingInformationProps } from './EstimatorInterfaces';

const useStyles = makeStyles(() => createStyles({
  estimatorCard: {
    height: '100%',
  },
  clarifyingButtons: {
    float: 'right',
    marginTop: '7px',
  },
  reviewMarkingBtn: {
    marginLeft: 'auto',
    color: '#587B9F',
  },
}));

const ClarifyingInformation: React.FC<IClarifyingInformationProps> = (
  { barcode, handleMissingInfo },
) => {
  const classes = useStyles();

  return (
    <Card className={classes.estimatorCard}>
      <CardContent>
        <HelpOutlineIcon color="primary" fontSize="medium" />
        <Typography gutterBottom>{'Clarifying Information'}</Typography>
        <Box my={1}>
          <Typography variant="body2">
            {'Review marking data, and/or mark this repair as missing data and in need of clarification.'}
          </Typography>
        </Box>
        <Box className={classes.clarifyingButtons}>
          <Link
            id="link-to-repair-marking-page"
            to={`/mark-repair/${barcode}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              id="review-marking-button"
              variant="text"
              className={classes.reviewMarkingBtn}
            >
              {'Review Marking'}
            </Button>
          </Link>
          <Button
            id="missing-info-id"
            variant="contained"
            color="secondary"
            onClick={() => handleMissingInfo('repairId')}
          >
            {'Missing Info'}
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ClarifyingInformation;
